/**
 * @description - _article-slider.js: Article sliders handling
 *
 * @author - Ruud Timmermans <r.timmermans@bluedragon.nl>
 */

import { tns } from 'tiny-slider/src/tiny-slider';
import '../../../node_modules/tiny-slider/src/tiny-slider.scss';

const sliderContainerClass = 'c-article-slider';

/**
 * @param {object} slider - the slider object
 */
function addSliderBtnClasses(slider) {
    const sliderInfo = slider.getInfo();
    const btnClass = `${sliderContainerClass}__btn`;
    sliderInfo.prevButton.className = `${btnClass} ${btnClass}--prev`;
    sliderInfo.nextButton.className = `${btnClass} ${btnClass}--next`;
}

const articleSlidersHolders = document.querySelectorAll('.js-article-slider');

if (articleSlidersHolders.length > 0) {
    articleSlidersHolders.forEach((articleSlidersHolder) => {
        let nrSlides = 3;
        let respSlides = 3;
        if (articleSlidersHolder.dataset.nrSlides) {
            nrSlides = parseInt(articleSlidersHolder.dataset.nrSlides);
        }

        if (nrSlides === 4) {
            respSlides = 3;
        }

        const slider = tns({
            container: articleSlidersHolder,
            autoplay: false,
            autoplayButton: false,
            gutter: 60,
            items: 1,
            controls: true,
            nav: true,
            navPosition: 'bottom',
            controlsText: ['', ''],
            responsive: {
                1080: {
                    items: nrSlides
                },
                940: {
                    items: respSlides
                },
                640: {
                    items: 2
                }
            }
        });

        addSliderBtnClasses(slider);
    });
}
